export interface UsersAccessViewModel {
    accessStepOrder: number;
    canNavigateToAccessStep: boolean;
    canManageExcludedUsers: boolean;
    users: Array<UserAccessViewModel>;
}

export interface UserAccessViewModel {
    id: string;
    fullName: string;
    email: string;
    accessOrigins: Array<UserAccessOrigin>;
    hasAccess: boolean;
    isActive: boolean;
}

export interface UserAccessTableViewModel extends UserAccessViewModel {
    hasAccessString: string;
    accessOriginsString: string;
}

export enum UserAccessOrigin {
    ContractManager = 1,
    AdditionalAccess = 2,
    BusinessAreaAccess = 3,
    AccessibleToAllUsers = 4,
    AccessExcluded = 5,
    Responsible = 7,
}
